export function getOrderStatusClassAndStr(status) {
    let order_status = '', order_status_class = ''
    if (status == 'pending') {
        order_status = 'Pending fullfilment';
        // order_status_class = 'pendingStatus';
    } else if (status == 'ready') {
        order_status = 'Ready to Collect';
        // order_status_class = 'readyStatus';
    } else if (status == 'matched' || status == 'assigned') {
        order_status = 'Matched';
        // order_status_class = 'matchedStatus';
    } else if (status == 'on_route_pickup') {
        order_status = 'On-route to Pickup';
        // order_status_class = 'onRoutePickupStatus';
    } else if (status == 'picked_up') {
        order_status = 'Picked up';
        // order_status_class = 'pickedUpStatus';
    } else if (status == 'arrived_at_pickedup') {
        order_status = 'Arrived at pickup';
        // order_status_class = 'arrivedPickedUpStatus';
    } else if (status == 'on_route') {
        order_status = 'On-route';
        // order_status_class = 'onRouteStatus';
    } else if (status == 'delivery_arrived') {
        order_status = 'Arrived to location';
        // order_status_class = 'deliveredArrivedStatus';
    } else if (status == 'delivered') {
        order_status = 'Delivered';
        // order_status_class = 'deliveredStatus';
    } else if (status == 'not_delivered') {
        order_status = 'Not delivered';
        // order_status_class = 'notDeliveredStatus';
    }
    return order_status
}
export function getOrderStatusListForVSelect_OrderView() {
    let status_list = [
        // { code: "assigned", label: "Assigned" },
        { code: "matched", label: "Matched" },
        { code: "on_route_pickup", label: "On-route to Pickup" },
        { code: "picked_up", label: "Picked up" },
        { code: "arrived_at_pickedup", label: "Arrived at pickup" },
        { code: "on_route", label: "On-route" },
        { code: "delivery_arrived", label: "Arrived to location" },
        { code: "delivered", label: "Delivered" },
        { code: "not_delivered", label: "Not delivered" },
    ]



    return status_list
}


// WEBPACK FOOTER //
// ./src/utils/helper-functions-doorder.js